"use client";
import CardForm, {
  CardFormBottom,
  CardFormInner,
} from "@/components/molecule/Cards/CardForm/CardForm";
import AuthLayout from "@/components/layouts/AuthLayout/AuthLayout";
import Input from "@/components/atom/Form/Input/Input";
import { useEffect, useState } from "react";
import CheckBox from "@/components/atom/Form/Checkbox/CheckBox";
import Button from "@/components/atom/Form/Button/Button";
import {Link, useRouter} from "@/navigation";
import { zodResolver } from "@hookform/resolvers/zod";
import { LoginInputSchema, TLoginInput } from "@/types/api/Auth/Login";
import { useForm } from "react-hook-form";
import { RegisterInputSchema, TRegisterInput } from "@/types/api/Auth/Register";
import {PAGE_URL, URL} from "@/utils/const/url";
import useFormErrorToast from "@/hooks/useFormToast";
import { useToast } from "@/contexts/ToastProvider";
import useRegister from "@/services/auth/useRegister";
import {
  ForgotPasswordInputSchema,
  TForgotPasswordInput,
} from "@/types/api/Auth/ForgotPassword";
import { useForgotPassword } from "@/services/auth/useForgotPassword";
import { AxiosError } from "axios";

const RegisterPage = () => {
  const {
    handleSubmit,
    register,
    formState: { errors, isLoading },
  } = useForm<TForgotPasswordInput>({
    resolver: zodResolver(ForgotPasswordInputSchema),
  });

  const toast = useToast();
  const router = useRouter();
  const { mutateAsync, isLoading: loading, error } = useForgotPassword();

  async function onSubmit(data: TForgotPasswordInput) {
    try {
      const res = await mutateAsync(data);
      toast.success("Na váš email bylo odesláno potvrzení na změnu hesla.");
      router.push(PAGE_URL.FORGOT_PASSWORD_RESET)
    } catch (err: any) {
      if (err.response.data.error) {
        toast.error(err.response.data.error);
        return;
      }
      toast.error("Nebylo možné resetovat heslo, kontaktujte prosím podporu");
    }
  }

  useFormErrorToast(errors);

  return (
    <CardForm>
      <h1>Zapomenuté heslo</h1>
      <CardFormInner onSubmit={handleSubmit((data) => onSubmit(data))}>
        <>
          <div>
            <Input
              type="text"
              label="Email"
              placeholder={"Email"}
              {...register("email")}
            />
          </div>
          <div
            className={"mt-3"}
            style={{
              textAlign: "center",
            }}
          >
            <Button label={"Obnovit heslo"} isLoading={isLoading || loading} />
          </div>
        </>
      </CardFormInner>
      <CardFormBottom>
        Vzpomněli jste si <Link href={URL.LOGIN}>Přihlásit se</Link>
      </CardFormBottom>
    </CardForm>
  );
};

export default RegisterPage;
